import {
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";

function AreYouSureModal({ open, onClose, newIEBDate }) {
  const handleCancel = () => {
    onClose(null);
  };

  const handleOk = () => {
    onClose(true);
  };

  return (
    <Dialog
      data-testid="are-you-sure-modal"
      open={open}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            width: "620px",
          },
        },
      }}
    >
      <DialogTitle>Change IEB Date</DialogTitle>
      <DialogContent>
        <Box>
          <Typography variant="h6" sx={{ color: "red" }}>
            ARE YOU SURE?
          </Typography>
          <Typography>
            This will change the IEB date to:{" "}
            <span>
              <b>{newIEBDate?.format("MM/DD/YYYY")}</b>
            </span>
          </Typography>
          <Typography>
            Updating the IEB date removes all IEB tags and resets all locals to
            NO IEB FILE SELECTED.
          </Typography>
          <Typography>This action cannot be reversed.</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        {/* Focus the safe (cancel) button so a keyboard Enter doesn't trigger the destructive action */}
        {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
        <Button className="siteBlueOutlined" autoFocus onClick={handleCancel}>
          Nevermind
        </Button>
        <Button className="siteRed" onClick={handleOk}>
          Yes, I want to change the IEB date and reset all the locals
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AreYouSureModal;
